import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from './core/Home';
import Signup from './user/Signup';
import Signin from './user/Signin';
import PrivateRoute from './auth/PrivateRoute';
import AdminRoute from './auth/AdminRoute';
import UserDashboard from './user/UserDashboard';
import AccountSettings from './account/AccountSettings';
import PasswordReset from './user/PasswordReset';
import ForgotPassword from './user/ForgotPassword';
import AccountVerification from './user/AccountVerification';
import ResendAccountVerification from './user/ResendAccountVerification';
import VerificationEmailSent from './user/VerificationEmailSent';
import { isAuthenticated } from './apiCallsHelper/authapicalls';
import AdminDashboard from './admin/AdminDashboard';



const MyRoutes = () => {

  const { user } = isAuthenticated();



  return (
    <BrowserRouter basename='/'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/signup' element={user ? <Navigate to="/" /> : <Signup />} />
        <Route path='/signin' element={<Signin />} />
        <Route path='/verify-account' element={<VerificationEmailSent />} />
        <Route path='/registration/verify/:verificationTkn' element={<AccountVerification />} />
        <Route path='/account/verify/resend' element={<ResendAccountVerification />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/auth/password/reset/:resetToken' element={<PasswordReset />} />
        <Route path='/user/dashboard' element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
        <Route path='/admin/dashboard' element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path='/user/account' element={<PrivateRoute><AccountSettings /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  )
}



export default MyRoutes;